import type { CoverMedia } from '@atlassian/jira-card-cover-manager/src/common/cover-media.types';
import type { IssueMediaCollection } from '../../../../../../../../model/issue/issue-media-types';
import { transformMediaDataForSingleIssue } from '../../../../../../../../services/card-covers/card-covers-transformer';

export const transformCardCoverPopoverData = (
	coverMedia: CoverMedia,
	issueId: string,
): IssueMediaCollection => {
	if (coverMedia) {
		if (coverMedia.__typename === 'JiraAttachmentBackground' && coverMedia.mediaConfig) {
			return {
				[issueId]: transformMediaDataForSingleIssue(coverMedia.attachment, coverMedia.mediaConfig),
			};
		}
		// don't do anything if we've received invalid or incomplete data
		return {};
	}
	// clear card cover data for the issue if coverMedia is null
	return {
		[issueId]: null,
	};
};
